exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../assets/typography.pcss"), undefined);

// module
exports.push([module.id, ".Disclaimer__disclaimer_text___1xVul{color:#767676}.Disclaimer__disclaimer_text___1xVul p{font-size:15px}.Disclaimer__disclaimer_text___1xVul a{color:#2e515c}.Disclaimer__disclaimer_text___1xVul b,.Disclaimer__disclaimer_text___1xVul strong{font-weight:700!important}", ""]);

// exports
exports.locals = {
	"disclaimer_text": "Disclaimer__disclaimer_text___1xVul " + require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../assets/typography.pcss").locals["bodyText"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/assets/Disclaimer/Disclaimer.pcss
// module id = 865
// module chunks = 0